export default "__VITE_ASSET__B6pcU$dn__"